import { render, staticRenderFns } from "./veSbzcJzwBuildcateEdit.vue?vue&type=template&id=342e4cfa&scoped=true"
import script from "./veSbzcJzwBuildcateEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcJzwBuildcateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342e4cfa",
  null
  
)

export default component.exports